import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { AddToList } from 'src/app/modules/customer-data/customers/models/member-summary.models';
import { CampaignAttribute } from '../models/campaign-add-attributes.interface';
import { campaignAdHocListAction } from '../models/campaign-adhoc-list.interface';
import { CampaignAdhocPoints } from '../models/campaign-adhoc-points.interface';
import { CampaignCoupon } from '../models/campaign-coupon.interface';
import { CampaignEmail } from '../models/campaign-email.interface';
import { CampaignTag } from '../models/campaign-give-tags.interface';
import { CampaignInAppMessage } from '../models/campaign-in-app-message.interface';
import {
  CampaignPushNotification,
  PushNotificationAccount,
} from '../models/campaign-push-notification.interface';
import { CampaignSMS } from '../models/campaign-sms.interface';
import { CampaignViber } from '../models/campaign-viber.interface';
import { AdhocListFilters } from '../models/lists.model';
import {
  Account,
  ActionType,
  AttributeCode,
  CampaignActionType,
  CampaignAdhocList,
  CampaignTestPayload,
  CouponSet,
  Flow,
  NexusAccount,
  PointSource,
  SmsTabConfig,
  Tag,
} from '../models/wizard.model';

export const HelpTextChanged = createAction('[Wizard- What]: Toggle Help Text Status');

export const ToggleActionCategory = createAction(
  '[Wizard What]: Toggle Action Category',
  props<{ actionType: CampaignActionType; isSelected: boolean }>(),
);

export const UpdateSmsConfig = createAction(
  '[Wizard What - SMS Tab] Update SMS Config',
  props<{ changes: Partial<SmsTabConfig> }>(),
);

export const nexusAccountsInit = createAction('[Wizard What] Nexus Accounts Init');

export const nexusAccountsSuccess = createAction(
  '[Wizard What] Nexus Accounts Success',
  props<{ nexusAccounts: NexusAccount[] }>(),
);

export const nexusAccountsFailure = createAction(
  '[Wizard What] Nexus Accounts Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const apifonSMSAccountsInit = createAction('[Wizard What] Apifon SMS Account Init');

export const apifonSMSAccountsSuccess = createAction(
  '[Wizard What] Apifon SMS Account Success',
  props<{ apifonSMSAccounts: Account[] }>(),
);

export const apifonSMSAccountsFailure = createAction(
  '[Wizard What] Apifon SMS Account Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const apifonViberAccountsInit = createAction('[Wizard What] Apifon Viber Account Init');

export const apifonViberAccountsSuccess = createAction(
  '[Wizard What] Apifon Viber Account Success',
  props<{ apifonViberAccounts: Account[] }>(),
);

export const apifonViberAccountsFailure = createAction(
  '[Wizard What] Apifon Viber Account Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const mstatViberAccountsInit = createAction('[Wizard What] MSTAT Viber Account Init');

export const mstatViberAccountsSuccess = createAction(
  '[Wizard What] MSTAT Viber Account Success',
  props<{ mstatViberAccounts: Account[] }>(),
);

export const mstatViberAccountsFailure = createAction(
  '[Wizard What] MSTAT Viber Account Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const omniViberAccountsInit = createAction('[Wizard What] OMNI Viber Account Init');

export const omniViberAccountsSuccess = createAction(
  '[Wizard What] OMNI Viber Account Success',
  props<{ omniViberAccounts: Account[] }>(),
);

export const omniViberAccountsFailure = createAction(
  '[Wizard What] OMNI Viber Account Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const apifonSMSAccountChange = createAction(
  '[Wizard What] Apifon SMS Account Change',
  props<{ apifonSMSAccount: Account }>(),
);

export const apifonViberAccountChange = createAction(
  '[Wizard What] Apifon Viber Account Change',
  props<{ apifonViberAccount: Account }>(),
);

export const mstatViberAccountChange = createAction(
  '[Wizard What] MSTAT Viber Account Change',
  props<{ mstatViberAccount: Account }>(),
);

export const omniViberAccountChange = createAction(
  '[Wizard What] OMNI Viber Account Change',
  props<{ omniViberAccount: Account }>(),
);

export const nexusAccountChange = createAction(
  '[Wizard What] NexusAccount Change',
  props<{ nexusAccount: NexusAccount }>(),
);

export const toggleLanguage = createAction(
  '[Wizard What] Toggle Language',
  props<{
    channel: 'SMS' | 'VIBER' | 'EMAIL';
    language: string;
    isChecked: boolean;
    isSingleSelect: boolean;
  }>(),
);

export const loadAttributeCodesInit = createAction('[Wizard What] Load Attribute Codes Init');

export const loadAttributeCodesSuccess = createAction(
  '[Wizard What] Load Attribute Codes Success',
  props<{ memberAttributeCodes: AttributeCode[]; personAttributeCodes: AttributeCode[] }>(),
);

export const loadAttributeCodesFailure = createAction(
  '[Wizard What] Load Attribute Codes Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const uploadViberImage = createAction(
  '[Wizard What - Viber] Upload Image',
  props<{ base64String: string }>(),
);

export const uploadViberImageSuccess = createAction(
  '[Wizard What - Viber] Upload Image Success',
  props<{ imageUrl: string }>(),
);

export const uploadViberImageFailure = createAction(
  '[Wizard What - Viber] Upload Image Failure',
  props<{ error: string }>(),
);

export const uploadInAppImage = createAction(
  '[Wizard What - In App] Upload Image',
  props<{ base64String: string; langCode: string }>(),
);

export const uploadInAppImageSuccess = createAction(
  '[Wizard What - In App] Upload Image Success',
  props<{ imageUrl: string; langCode: string }>(),
);

export const uploadInAppImageFailure = createAction(
  '[Wizard What - In App] Upload Image Failure',
  props<{ error: string | null; langCode: string }>(),
);

export const mailchimpAccountsInit = createAction('[Wizard What] MAILCHIMP Account Init');

export const mailchimpAccountsSuccess = createAction(
  '[Wizard What] MAILCHIMP Account Success',
  props<{ mailchimpAccounts: Account[] }>(),
);

export const mailchimpAccountsFailure = createAction(
  '[Wizard What] MAILCHIMP Account Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const enboxAccountsInit = createAction('[Wizard What] ENBOX Account Init');

export const enboxAccountsSuccess = createAction(
  '[Wizard What] ENBOX Account Success',
  props<{ enboxAccounts: Account[] }>(),
);

export const enboxAccountsFailure = createAction(
  '[Wizard What] ENBOX Account Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const contactPigeonAccountsInit = createAction('[Wizard What] ContactPigeon Account Init');

export const contactPigeonAccountsSuccess = createAction(
  '[Wizard What] ContactPigeon Account Success',
  props<{ contactPigeonAccounts: Account[] }>(),
);

export const contactPigeonAccountsFailure = createAction(
  '[Wizard What] ContactPigeon Account Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const aws_sesAccountsInit = createAction('[Wizard What] AWS_SES Account Init');

export const aws_sesAccountsSuccess = createAction(
  '[Wizard What] AWS_SES Account Success',
  props<{ aws_sesAccounts: Account[] }>(),
);

export const aws_sesAccountsFailure = createAction(
  '[Wizard What] AWS_SES Account Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const QC_Message_AppAccountsInit = createAction('[Wizard What] QC_Message_App Account Init');

export const QC_Message_AppAccountsSuccess = createAction(
  '[Wizard What] QC_Message_App Account Success',
  props<{ QC_Message_AppAccounts: Account[] }>(),
);

export const QC_Message_AppAccountsFailure = createAction(
  '[Wizard What] QC_Message_App Account Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const aws_sesSendersInit = createAction(
  '[Wizard What] AWS_SES Senders Init',
  props<{ sesAccountName: string }>(),
);

export const aws_sesSendersSuccess = createAction(
  '[Wizard What] AWS_SES Senders Success',
  props<{ aws_sesSenders: any }>(),
);

export const aws_sesSendersFailure = createAction(
  '[Wizard What] AWS_SES Senders Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const uploadFileInit = createAction(
  '[Wizard What] Upload File Init',
  props<{
    file: any;
    languageCode: string;
    field: 'emailTemplatePath';
  }>(),
);

export const uploadFileSuccess = createAction(
  '[Wizard What] Upload File Success',
  props<{
    fileUrl: string;
    languageCode: string;
    field: 'emailTemplatePath';
  }>(),
);

export const uploadFileFailure = createAction(
  '[Wizard What] Upload File Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const openEmailPreviewModal = createAction(
  '[Wizard What] Open Email Preview Modal',
  props<{ templatePath: string }>(),
);

export const openPersonalizedModal = createAction('[Wizard What] Open Personalized Modal');

export const closePersonalizedModal = createAction('[Wizard What] Close Personalized Modal');

export const openTemplateModal = createAction('[Wizard What] Open Template Modal');

export const closeTemplateModal = createAction('[Wizard What] Close Template Modal');

export const fetchPushNotificationAccountsInit = createAction(
  '[Wizard What] Fetch Push Notification Accounts Init',
  props<{ vendor: string }>(),
);

export const fetchPushNotificationAccountsSuccess = createAction(
  '[Wizard What] Fetch Push Notification Accounts Success',
  props<{ accounts: PushNotificationAccount[] }>(),
);

export const fetchPushNotificationAccountsFailure = createAction(
  '[Wizard What] Fetch Push Notification Accounts Failure',
  props<{ error: any }>(),
);

export const toggleInAppLanguage = createAction(
  '[Wizard What] Toggle In-App Language',
  props<{ languageCode: string; isChecked: boolean }>(),
);

export const UpdateCoupon = createAction(
  '[Wizard What] Update Coupon',
  props<{ coupon: Partial<CampaignCoupon> }>(),
);

export const ToggleCouponAction = createAction(
  '[Wizard What] Toggle Coupon Action',
  props<{
    actionField: keyof Pick<
      CampaignCoupon,
      'useAvailableCoupon' | 'useAvailableCouponForMember' | 'couponReminder' | 'customCouponAction'
    >;
  }>(),
);

export const UpdateCustomCouponAction = createAction(
  '[Wizard What] Update Custom Coupon Action',
  props<{
    update: Partial<{ type: string | null; customGenerationKey: string | null }>;
  }>(),
);

export const updateInAppMessageConfig = createAction(
  '[Wizard What] Update In-App Message Config',
  props<{ payload: Partial<CampaignInAppMessage> }>(),
);

export const updatePushNotificationConfig = createAction(
  '[Wizard What] Update Push Notification Config',
  props<{ payload: Partial<CampaignPushNotification> }>(),
);

export const updateCampaignSMS = createAction(
  '[Wizard What - SMS Tab] Update Campaign SMS',
  props<{ changes: Partial<CampaignSMS> }>(),
);

export const updateCampaignViber = createAction(
  '[Wizard What - Viber Tab] Update Campaign Viber',
  props<{ changes: Partial<CampaignViber> }>(),
);

export const updateCampaignEmail = createAction(
  '[Wizard What - Email Tab] Update Campaign Email',
  props<{ changes: Partial<CampaignEmail> }>(),
);

export const getCouponSetsInit = createAction('[Wizard What] Get CouponSets Init');

export const getCouponSetsSuccess = createAction(
  '[Wizard What] Get CouponSets Success',
  props<{ couponSets: CouponSet[] }>(),
);

export const getCouponSetsFailure = createAction(
  '[Wizard What] Get CouponSets Failure',
  props<{ error: any }>(),
);

export const FilterCouponSets = createAction(
  '[Wizard What] Filter Coupon Sets',
  props<{ filter: string }>(),
);

export const getCouponActionsInit = createAction('[Wizard What] Get Coupon Actions Init');

export const getCouponActionsSuccess = createAction(
  '[Wizard What] Get Coupon Actions Success',
  props<{ couponActions: string[] }>(),
);

export const getCouponActionsFailure = createAction(
  '[Wizard What] Get Coupon Actions Failure',
  props<{ error: any }>(),
);

export const getPointSourcesInit = createAction('[Wizard What] Get PointSources Init');

export const getPointSourcesSuccess = createAction(
  '[Wizard What] Get PointSources Success',
  props<{ pointSources: PointSource[] }>(),
);

export const getPointSourcesFailure = createAction(
  '[Wizard What] Get PointSources Failure',
  props<{ error: any }>(),
);

export const updateCampaignAdhocPoints = createAction(
  '[Wizard What - Points Tab] Update Campaign AdhocPoints',
  props<{ changes: Partial<CampaignAdhocPoints> }>(),
);

export const updateCampaignAdHocListAction = createAction(
  '[Wizard What - Points Tab] Update Campaign AdhocListAction',
  props<{ changes: Partial<campaignAdHocListAction> }>(),
);

export const updateCampaignReport = createAction(
  '[Wizard What - Points Tab] Update Campaign Record',
  props<{ campaignReport: boolean }>(),
);

export const getTagsInit = createAction('[Wizard What] Get Tags Init');

export const getTagsSuccess = createAction(
  '[Wizard What] Get Tags Success',
  props<{ tags: Tag[] }>(),
);

export const getTagsFailure = createAction(
  '[Wizard What] Get Tags Failure',
  props<{ error: any }>(),
);

export const updateCampaignTag = createAction(
  '[Wizard What - Tags Tab] Update Campaign Tag',
  props<{ changes: Partial<CampaignTag> }>(),
);

export const getFlowsInit = createAction('[Wizard What] Get Flows Init');

export const getFlowsSuccess = createAction(
  '[Wizard What] Get Flows Success',
  props<{ flows: Flow[] }>(),
);

export const getFlowsFailure = createAction(
  '[Wizard What] Get Flows Failure',
  props<{ error: any }>(),
);

export const updateCampaignFlow = createAction(
  '[Wizard What - Flows Tab] Update Campaign Flow',
  props<{ flowId: string | null }>(),
);

export const updateCampaignAttribute = createAction(
  '[Wizard What - Add Attributes Tab] Update Campaign Attribute',
  props<{ changes: Partial<CampaignAttribute> }>(),
);

export const showAdhocList = createAction(
  '[Wizard What] Show Adhoc List And Action Buttons',
  props<{ actionType: ActionType }>(),
);

export const fetchAdhocListData = createAction(
  '[Wizard What] Fetch Adhoc List Data',
  props<{ filters: AdhocListFilters }>(),
);

export const fetchAdhocListDataSuccess = createAction(
  '[Wizard What] Fetch Adhoc List Data Success',
  props<{ data: AddToList[] }>(),
);

export const fetchAdhocListDataFailure = createAction(
  '[Wizard What] Fetch Adhoc List Data Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const constructTestDataPayload = createAction(
  '[Wizard What] Construct Test Data Payload',
  props<{ testPayLoad: CampaignTestPayload }>(),
);

export const sendTestDataPayloadSuccess = createAction(
  '[Wizard What] Send Test Data Payload Success',
);

export const sendTestDataPayloadFailure = createAction(
  '[Wizard What] Construct Test Data Payload Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const testCampaignAdhocListItemChanged = createAction(
  '[Wizard- What]: Test Campaign Adhoc List Item Changed',
  props<{ testAdhocListItem: CampaignAdhocList; actionType: ActionType }>(),
);
